import { URLS } from '../config';

export interface RequestChecker {
  isRefreshTokenRequest(body: string | undefined): boolean
  isBffRequest(url: string | undefined): boolean
}

export const requestChecker = () => {
  const isRefreshTokenRequest = (body: string | undefined): boolean => {
    if (!body) return false;
    try {
      const parsed: unknown = JSON.parse(body);
      if (typeof parsed !== 'object' || parsed === null) {
        return false;
      }
      const operation = parsed as Record<string, unknown>;
      const query = operation.query;
      const isRefreshOpName = operation.operationName === "refreshToken";
      const refreshTokenQuery = /\bmutation\s+refreshToken\b/
      const isRefreshInQuery = typeof query === "string" && refreshTokenQuery.test(query);

      return isRefreshOpName || isRefreshInQuery;
    } catch {
      return false;
    }
  }

  const isBffRequest = (url: string | undefined): boolean => {
    if (!url) return false;
    return url.includes(URLS.BFF_URL);
  }

  return { isBffRequest, isRefreshTokenRequest }
}